import React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/lib/ui/select'
import { Textarea } from '~/lib/ui/textarea'

const UpdateYourLinkedinPageOne = () => {
  const {
    formattedExerciseName,
    getResponse,
    updateResponse,
    handleChange,
    exerciseIndex,
    trackContent,
  } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageOneTranslations = t('pages.0')
  const questions = pageOneTranslations.questions
  const { current_about_section: _, ...rest } = trackContent[0] || {}
  const [selectQuestions, setSelectQuestions] = React.useState(
    Object.values(rest) || [],
  )

  const handleSelectChange = (section, slug, event) => {
    updateResponse(section, slug, event)
    const selectedQuestion = questions.find(
      (question) => question.slug === slug,
    )
    const selectedValue = event
    const selectedQuestionIndex = selectQuestions.findIndex(
      (question) => question.slug === slug,
    )
    if (selectedQuestionIndex === -1) {
      setSelectQuestions((prev) => [
        ...prev,
        { ...selectedQuestion, selectedValue },
      ])
    } else {
      const updatedQuestions = [...selectQuestions]
      updatedQuestions[selectedQuestionIndex].selectedValue = selectedValue
      setSelectQuestions(updatedQuestions)
    }
  }

  return (
    <div className="questions">
      <p>{pageOneTranslations.start_reviewing}</p>
      {questions.map((question, index) => (
        <div
          key={index}
          className="mb-8 w-full font-roboto text-base font-medium"
        >
          <div className="flex w-full flex-col">
            <h2 className="!mb-1 italic">{question.category}</h2>
            <label className="!mb-1">{question.question}</label>
            {question.type === 'text' && (
              <Textarea
                className="min-h-[125px] w-full rounded-[20px]"
                onChange={(e) => handleChange(exerciseIndex, question.slug, e)}
                value={getResponse(exerciseIndex, question.slug) || ''}
              />
            )}
            {question.type === 'select' && (
              <Select
                onValueChange={(e) =>
                  handleSelectChange(exerciseIndex, question.slug, e)
                }
                value={getResponse(exerciseIndex, question.slug) || ''}
                className="w-1/4 rounded-[20px] border border-[#D3D3D3] bg-[#F7FAFC] p-3 font-roboto text-base"
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select an option" />
                </SelectTrigger>
                <SelectContent>
                  {question.choices.map((choice, index) => (
                    <SelectItem key={index} value={choice}>
                      {choice}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            )}
          </div>
        </div>
      ))}
      {selectQuestions.length > 6 &&
        !selectQuestions.some(
          (question) => question.selectedValue === 'No',
        ) && <p>{pageOneTranslations.results.good_result}</p>}
      {selectQuestions.length > 6 &&
        selectQuestions.some((question) => question.selectedValue === 'No') && (
          <p>{pageOneTranslations.results.ok_result}</p>
        )}
    </div>
  )
}

export default UpdateYourLinkedinPageOne
